interface SelectionStoreNode {
  selected?: boolean
}

interface SelectionStoreSnapshot {
  nodeInternals: Map<string, SelectionStoreNode>
}

export function getSelectedNodeCount(store: SelectionStoreSnapshot): number {
  let count = 0
  store.nodeInternals.forEach((node) => {
    if (node.selected) count += 1
  })
  return count
}

export function shouldShowSingleNodeDetails(selectedNodeCount: number): boolean {
  return selectedNodeCount <= 1
}
